import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./common-header.scss";

import { useAppSelector } from "../../app/hooks";
import { currentUser } from "../../reducers/authSlice";
import { Rating } from "react-simple-star-rating";
import { capitalizeFullString } from "../../utils/common";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { useTranslationContext } from "../../context/locale.context";
import IntegolfLoader from "../integolf-loader/integolf-loader";
interface CommonHeaderProps {
  sectionTitle?: any;
  hasExportButton?: boolean;
  hasAddProductButton?: boolean;
  hasRatingVisible?: boolean;
  disabledAddProductButton?: boolean;
  hasPendingProducts?: boolean
}

const CommonHeader: FC<CommonHeaderProps> = ({
  sectionTitle,
  hasExportButton,
  hasAddProductButton,
  hasRatingVisible,
  disabledAddProductButton,
  hasPendingProducts
}) => {

  const { firstname, lastname } = useAppSelector(currentUser);
  const navigate = useNavigate();
  const {t,i18n}=useTranslation("");

  if (!i18n.isInitialized) {
   <IntegolfLoader show/>
  }

  return (
    <section className="commonHeader">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md">
            <h1>
            {t("headerComponent.WelcomeText")},{" "}
              <span>
                {capitalizeFullString(firstname ?? '')} { capitalizeFullString(lastname ?? '')}
              </span>
            </h1>
            <h6>{sectionTitle}</h6>
          </div>
          {sectionTitle == "Listings" && (
            <div className="col-12 col-md-auto">
              <button
                type="button"
                className="button button-primary button-rounded button-min-120 fw600"
                onClick={() => navigate("/register")}
              >
                {t("headerComponent.AddCourseButton")}
              </button>
            </div>
          )}
          {hasAddProductButton && (
            <div className="col-12 col-md-auto">
              <button
                type="button"
                disabled={disabledAddProductButton || hasPendingProducts}
                title={
                  disabledAddProductButton
                    ? hasPendingProducts
                      ? t("headerComponent.productionAdditonToottip.confirmationText")
                      : t("headerComponent.productionAdditonToottip.minErrorText")
                    : ""
                }
                className="button button-primary button-rounded button-min-120 fw600"
                onClick={() => navigate("/product/add")}
              >
                {t("headerComponent.AddNew")}
              </button>
            </div>
          )}
          {hasExportButton && (
            <div className="col-12 col-md-auto">
              <a href={void 0} className="color-s3 fw600 _linkButton">
                <em className="icon-export me-2"></em> {t("headerComponent.Export")}
              </a>
            </div>
          )}
          {hasRatingVisible && (
            <div className="col-auto text-center _ratingColumn">
              <div className="ratingBlock mb-2">
                <Rating
                  initialValue={2}
                  showTooltip
                  size={17}
                  fillColor={"#FF8F28"}
                  tooltipArray={["1.0", "2.0", "3.0", "4.0", "5.0"]}
                  readonly
                />
              </div>
              <p className="mb-0 fontsize-10 fw500">{t("headerComponent.RatingHeading")}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CommonHeader;
